import React from 'react';
import { ClockIcon, LayersIcon, RouteIcon, HelpCircleIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  help: HelpCircleIcon,
  route: RouteIcon,
  clock: ClockIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-ink" data-id="element-141" data-mp="2vpg424c9szgk">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-142" data-mp="39hmagypmfs2t">
        <p className="inline-block rounded bg-forge px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-143" data-mp="39jywpo2ewolo">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-anton text-2xl uppercase leading-tight sm:text-3xl" data-id="element-144" data-mp="3jeqyl4311xm9">
          Querés aprender herrería y fabricar muebles industriales,{' '}
          <span className="bg-gold px-1" data-id="element-145" data-mp="1p2u2gxtn43kv">pero no sabés por dónde empezar.</span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-steel" data-id="element-146" data-mp="1k49cdr83r0a5">
          Si estás comenzando desde cero o querés aprender una habilidad para
          fabricar tus propios muebles y ofrecer trabajos, probablemente
          conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-147" data-mp="scqqje8b9pml">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg border-l-4 border-forge bg-paper p-2.5 text-left" data-id="element-148" data-mp="123v4cam934fu" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-ink" data-id="element-149" data-mp="1c33vywtn86z1">
                  <Icon size={15} className="text-forge" data-id="element-150" data-mp="1g2uhom4bbwwp" />
                </span>
                <div data-id="element-151" data-mp="3du75firsrfi0">
                  <h3 className="text-sm font-extrabold uppercase leading-tight" data-id="element-152" data-mp="3duqgqgmxz5n2">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-steel sm:text-sm" data-id="element-153" data-mp="p00n7wux3z2a">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}